<!-- Activity details component template -->
<div class="activity-details-modal">
  <div class="modal-header">
    <h2>Detalii activitate</h2>
  </div>
  
  <div class="activity-content" *ngIf="!isLoading">
    <div class="details-section">
      <h3>Informații generale</h3>
      
      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label">Titlu:</div>
          <div class="detail-value">{{ activity?.title || 'N/A' }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">Status:</div>
          <div class="detail-value">{{ getStatusLabel(activity?.status || 'scheduled') }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">Data:</div>
          <div class="detail-value">{{ activity?.scheduled_date || 'N/A' }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">Ora:</div>
          <div class="detail-value">{{ formatTime(activity?.start_time || '') }}</div>
        </div>
      </div>
    </div>
    
    <div class="notes-section">
      <h3>Observații</h3>
      <div class="notes-content">
        <div *ngIf="activity?.notes; else emptyNotes">
          {{ activity?.notes }}
        </div>
        <ng-template #emptyNotes>
          <div class="empty-notes">Nu există observații pentru această activitate.</div>
        </ng-template>
      </div>
    </div>
  </div>
  
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner">Se încarcă...</div>
  </div>
  
  <div class="modal-actions">
    <div class="action-group">
      <button type="button" (click)="editActivity()" [disabled]="isLoading">Editează</button>
      <button type="button" (click)="duplicateActivity()" [disabled]="isLoading">Duplică</button>
    </div>
    
    <div class="action-group">
      <button type="button" (click)="closeModal()">Închide</button>
    </div>
  </div>
</div>